import { fetchToken } from "../../../common/FetchCookie";
import {
  BASE_URL,
  CANDIDATE,
  CORE_EDUCATIONS,
  CORE_LOCATIONS,
  CORE_SKILLS,
  EMPLOYER,
  JOBS,
} from "../../../common/URLs";

const parseJsonSafe = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

export const createJob = async (data) => {
  const token = await fetchToken();

  const response = await fetch(`${BASE_URL}/${EMPLOYER}/${JOBS}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  });

  const responseData = await parseJsonSafe(response);

  if (!response.ok) {
    const message =
      responseData?.message ||
      responseData?.error ||
      `Request failed with status ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.data = responseData;
    throw err;
  }

  return responseData;
};

export const fetchCoreEducation = async () => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CORE_EDUCATIONS}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const data = await response.json(); // FIXED: removed (response) argument
    return data.response;
  } catch (error) {
    console.error(" Error in making the post request: ", error);
    return error;
  }
};

export const fetchCoreLocation = async () => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CORE_LOCATIONS}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const data = await response.json(); // FIXED
    return data.response;
  } catch (error) {
    console.error(" Error in making the post request: ", error);
    return error;
  }
};

export const fetchCoreSkills = async () => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CORE_SKILLS}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const data = await response.json(); // FIXED
    return data.response;
  } catch (error) {
    console.error(" Error in making the post request: ", error);
    return error;
  }
};

// Updated: accepts keyword and uses fetchToken internally (no token passed from component)
export const fetchSuggestedSkills = async (keyword = "") => {
  const token = await fetchToken();
  try {
    const response = await fetch(
      "https://api.indiahirings.com/candidate/fetch-core-skills?keyword=" +
      encodeURIComponent(keyword),
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const data = await response.json(); // FIXED
    return data.response;
  } catch (error) {
    console.error(" Error in making the post request: ", error);
    return error;
  }
};

export const saveSkills = async (token, data) => {
  try {
    const response = await fetch(
      "https://api.indiahirings.com/candidate/candidate-skills",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    // console.log("Error :- ", error);
    return error;
  }
};